import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Generated by Copilot — Migrated from UserfrontProvider to ClerkProvider
import { ClerkProvider } from "@clerk/react";
import { esMX } from "@clerk/localizations";

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} localization={esMX}>
        <App />
      </ClerkProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
